import React from 'react'
import 'typeface-rubik'
import GA from './src/components/analytics'
import './src/design/components.css'
import './src/design/typeface-ranchers.css'

export const wrapPageElement = ({ element, props }) => {
  return <GA>{element}</GA>
}
